//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { startOfUTCDay } from "./usageRange";

// lastCompleteDay returns the last complete UTC day, formatted as
// YYYY-MM-DD, for display in the "data through ..." caption shown on both
// usage views. It is the same boundary usageRangeFor uses for `to`
// (exclusive): everestd only sets a usage item's credit cost once its
// billing period closes, so today's usage does not exist yet and is
// deliberately excluded from every range. Shared by OrganizationUsageView
// and DeploymentUsageView rather than duplicated, since both need the exact
// same boundary the range logic already enforces.
//
// `now` is required, with no internal `new Date()` fallback - same
// treatment as useFetchCreditUsage's `now`, and for the same reason: both
// views compute `now` exactly once per render and pass that single value to
// every call that needs "the current time" (both useFetchCreditUsage calls,
// the clampPeriodToRange window, and this caption). Before this, the
// caption read its own independent clock: a render straddling the UTC
// midnight boundary could have the chart's data window computed from one
// side of midnight while this printed a day name from the other - a wrong
// date shown right next to the data it is supposed to describe, which is
// worse than the (invisible) data-window mismatch that bug pattern caused
// elsewhere, since this one is read directly off the page.
export const lastCompleteDay = (now: Date): string => {
  const d = startOfUTCDay(now);
  d.setUTCDate(d.getUTCDate() - 1);
  return d.toISOString().slice(0, 10);
};
